export default __webpack_public_path__ + "static/secondIcon-05411a21b3bddae64303fcfb352ec9b9.png";